import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import type { ModelSummary } from "@shared/types";
import { StatusPill } from "../components/Status";

export function Models() {
  const [models, setModels] = useState<ModelSummary[]>([]);
  useEffect(() => {
    api<{ models: ModelSummary[] }>("/api/models").then((r) => setModels(r.models)).catch(() => setModels([]));
  }, []);
  return (
    <section className="page-hero">
      <div className="wrap">
        <p className="kicker">Model Observatory</p>
        <h1>Persistent model records</h1>
        <p className="lede">No single quality score. Completeness, calibration evidence, terrain currency, and conflicts stay separate.</p>
        <div className="results">
          {models.map((m) => (
            <Link className="result" key={m.id} to={`/model/${m.slug}`}>
              <div className="record-meta">
                <span>{m.systemName}</span>
                <span>{m.software}</span>
                <span>{m.dimensionality}</span>
                <StatusPill status={m.epistemic} />
              </div>
              <h3>{m.name}</h3>
              <p className="muted small">{m.adoptionStatus}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
